module.exports = __webpack_public_path__ + "static/media/ACDW1.27127a94.svg";